import { Toaster } from "@/components/ui/toaster";
import { Toaster as Sonner } from "@/components/ui/sonner";
import { TooltipProvider } from "@/components/ui/tooltip";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { CookieBanner } from "@/components/CookieBanner";
import { ScrollToTop } from "@/components/ScrollToTop";
import Index from "./pages/Index";
import Candidates from "./pages/Candidates";
import About from "./pages/About";
import Verpachtung from "./pages/Verpachtung";
import Unternehmen from "./pages/Unternehmen";
import Managementleistungen from "./pages/Managementleistungen";
import JobPage from "./pages/JobPage";
import Datenschutz from "./pages/Datenschutz";
import Impressum from "./pages/Impressum";
import NotFound from "./pages/NotFound";
import TriggerSync from "./pages/TriggerSync";

const queryClient = new QueryClient();

const App = () => {
  return (
    <QueryClientProvider client={queryClient}>
      <TooltipProvider>
        <Toaster />
        <Sonner />
        <BrowserRouter>
          <ScrollToTop />
          <CookieBanner />
          <Routes>
            <Route path="/" element={<Index />} />
            {/* Redirects for old URLs */}
            <Route path="/ueber_uns.html" element={<Navigate to="/#about" replace />} />
            <Route path="/jobangebote.html" element={<Navigate to="/bewerbende" replace />} />
            <Route path="/bewerber.html" element={<Navigate to="/bewerbende" replace />} />
            <Route path="/bewerbende.html" element={<Navigate to="/bewerbende" replace />} />
            <Route path="/unternehmen.html" element={<Navigate to="/unternehmen" replace />} />
            <Route path="/impressum.html" element={<Navigate to="/impressum" replace />} />
            <Route path="/datenschutz.html" element={<Navigate to="/datenschutz" replace />} />
            <Route path="/verpachtungen.html" element={<Navigate to="/verpachtung" replace />} />
            <Route path="/index.html" element={<Navigate to="/" replace />} />
            <Route path="/bewerber" element={<Navigate to="/bewerbende" replace />} />
            <Route path="/jobangebote" element={<Navigate to="/stellenangebote" replace />} />
            <Route path="/bewerbende" element={<Candidates />} />
            <Route path="/stellenangebote" element={<Candidates />} />
            <Route path="/stellenangebote/:jobId" element={<JobPage />} />
            <Route path="/jobs/:jobId" element={<JobPage />} />
            <Route path="/ueber-uns" element={<About />} />
            <Route path="/managementleistungen" element={<Managementleistungen />} />
            <Route path="/verpachtung" element={<Verpachtung />} />
            <Route path="/unternehmen" element={<Unternehmen />} />
            <Route path="/datenschutz" element={<Datenschutz />} />
            <Route path="/impressum" element={<Impressum />} />
            <Route path="/admin/sync-jobs" element={<TriggerSync />} />
            {/* ADD ALL CUSTOM ROUTES ABOVE THE CATCH-ALL "*" ROUTE */}
            <Route path="*" element={<NotFound />} />
          </Routes>
        </BrowserRouter>
      </TooltipProvider>
    </QueryClientProvider>
  );
};

export default App;
